import React from 'react'
import './LabelList.scss'

const LabelList = ({ labelList, onDelete }) => {
  return (
    <div className="list-section">
      <ul className="label-list">
        {labelList.map((item, index) => (
          <li key={index} className="list-item">
            <span>
              <strong>{item.TITLE}</strong> ({item.CN_TITLE}) - {item.SIZE}{' '}
              {item.UNIT} - ${item.PRICE}
            </span>
            <button className="delete-btn" onClick={() => onDelete(index)}>
              ×
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LabelList
